module.exports = __webpack_public_path__ + "static/media/fair.5a36017a.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/fair.JPG
// module id = 487
// module chunks = 0